import './Main.css';
import Header from './Header';
import Content from './Content';
import React from 'react';

function Main() {
  return (
    <div>
      <Header />
      <Content />
    </div>
  );
}

export default Main;
